// extracted by mini-css-extract-plugin
export var circle = "_v-2";
export var icon = "_v-a";
export var iconHighlight = "_v-0";
export var lg = "_v-8";
export var md = "_v-7";
export var outline = "_v-4";
export var sm = "_v-6";
export var square = "_v-1";
export var xl = "_v-9";
export var xs = "_v-5";
export var xxs = "_v-3";